// function to flatten data queried from CMS.
// Some fields are meant to be singular but due to
// datoCMS data modelling, there is a need for a compromise.
export function flatten(payload, fields = []) {
  payload = Object.assign({}, payload)
  fields.forEach(
    (field) => (payload[field] = [].concat(payload[field]).shift())
  )
  return payload
}
